import './App.css';
import './i18n';
import { useEffect } from 'react';
import router from './router';
import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from './layout';

function App() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('header.title');
  }, [t]);

  return (
    <Suspense fallback={<div>Loading translations...</div>}>
      <Layout>
        <Routes>
          {router.map((route, i) => {
            return <Route
              key={i}
              path={route.path}
              element={route.element}
            />
          })}
        </Routes>
      </Layout>
    </Suspense>
  );
}

export default App;